export const apiEndpoint = "https://try.whattowear.com.my/survey/api/";

export const APIResult = {
    TIME_OUT: -1,
    FAILED : 0,
    SUCCESS : 1,
};

export const delay = 500;